export default __webpack_public_path__ + "static/media/icon-logo-news.ded37163.svg";